import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityAubervilliersPage() {
  const data = citiesData.find((c) => c.slug === "aubervilliers")!;
  return <CityPage data={data} />;
}
